import 'angular:locale/data:en';
import 'zone.js';
import './src/polyfills.ts';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "en";
